import { QueuesTabContainer } from '../../queuesTab/QueuesTabContainer';

/** Route element for Kolejki (/main/dod/queues). */
export const QueuesRoute = (): JSX.Element => <QueuesTabContainer />;
